import Avatar from 'Components/UI_Library/Avatar';
import { ReactComponent as SignOut } from 'Components/UI_Library/Icons/SignOut.svg';
import { ReactComponent as UserSetup } from 'Components/UI_Library/Icons/UserSetup.svg';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import classes from './Header.module.css';
import DropDown from 'Components/UI_Library/Dropdowns/DropDown';
import { ReactComponent as Plus } from 'Components/UI_Library/Icons/Plus.svg';
import Button from 'Components/UI_Library/FormElements/Button';
import { useGetUser } from 'Backend/users/getUser';

const Header = (props) => {
    const history = useNavigate();
    const location = useLocation();
    const [createLink, setCreateLink] = useState('');

    // USER
    const { data: user } = useGetUser();

    useEffect(() => {
        if (location?.pathname && typeof location?.pathname === 'string')
            setCreateLink(mapCreateLink(location.pathname.toLowerCase()));
    }, [location?.pathname]);

    const mapCreateLink = (path) => {
        switch (path) {
            case '/accounts':
                return '/accounts/add';
            case '/payments/all':
            case '/payments/drafts':
            case '/payments/needs%20approval':
            case '/payments/scheduled':
            case '/payments/awaiting%20funds':
            case '/payments/inflight':
            case '/payments/failed':
            case '/payments/done':
                return '/payments/new';
            case '/expenses/all':
            case '/expenses/open':
            case '/expenses/pending':
            case '/expenses/needs-approval':
            case '/expenses/failed':
            case '/expenses/closed':
                return '/expenses/open/new';
            case '/budgets/all':
            case '/budgets/draft':
            case '/budgets/needs-approval':
            case '/budgets/active':
            case '/budgets/archived':
                return '/budgets/all/new';
            case '/cards/all':
            case '/cards/pending':
            case '/cards/active':
            case '/cards/locked':
            case '/cards/cancelled':
                return '/cards/all/new';
            case '/bills/drafts':
            case '/bills/needsapproval':
            case '/bills/awaitingpayment':
            case '/bills/paymentprocessing':
            case '/bills/paid':
            case '/bills/rejected':
            case '/bills/archived':
                return '/bills/drafts/upload';
            default:
                return '';
        }
    };

    return (
        <header className={classes.headerBackground}>
            <div className={classes.headerWrap}>
                <h1 className={classes.headerTitle}>{props.title}</h1>

                <div className={classes.headerContent}>
                    <div className={classes.settingsBox}>
                        <DropDown
                            id="user-dropdown"
                            items={[
                                {
                                    option: 'User setup',
                                    icon: <UserSetup fill="#48536F" style={{ height: '12px' }} />,
                                    onClick: () => history('/setup/user'),
                                },
                                {
                                    option: 'Sign out',
                                    icon: <SignOut fill="#48536F" style={{ height: '12px' }} />,
                                    onClick: () => history('/signout'),
                                },
                            ]}
                            placeholder={<Avatar user={user} size={35} flat />}
                            makeSelection={(_, option) => option.onClick()}
                            overrideSelection
                            style={{ padding: 0, height: '35px', width: '35px', marginBottom: 0, borderRadius: '50%' }}
                            containerStyle={{
                                padding: 0,
                                height: '35px',
                                width: '35px',
                                display: 'flex',
                                background: '#e5e5e5',
                                borderRadius: '50%',
                            }}
                            placeholderStyle={{ padding: 0, display: 'flex', justifyContent: 'center' }}
                            dropdownWidth="150px"
                            dropdownHorizontalShift={-110}
                            ghost
                            iconFill
                        />
                    </div>
                </div>
                <div className={classes.svgContainer}>
                    {createLink ? (
                        <Button
                            className={classes.createLink}
                            type="white-circle-blur"
                            href={createLink}
                            icon={<Plus style={{ fill: '#FFF', height: '16px' }} />}
                        />
                    ) : null}
                </div>
            </div>
            <div className={classes.headerShadow} />
            <div className={classes.bottomRounded} />
        </header>
    );
};

export default Header;
